module.exports = __webpack_public_path__ + "static/media/filter-icon.bd78c130.svg";